module.exports = __webpack_public_path__ + "img/appAsset-brand--santander.c33386e1.svg";